import { render, staticRenderFns } from "./RunCommandOnObject.vue?vue&type=template&id=60b677bf&scoped=true"
import script from "./RunCommandOnObject.vue?vue&type=script&lang=js"
export * from "./RunCommandOnObject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b677bf",
  null
  
)

export default component.exports